export default __webpack_public_path__ + "media/color/drgn-7d2f00a8.svg";